import type {Icon} from '@primer/octicons-react'
import styles from './readonly-comment-box.module.css'

import readonlyCommentBox from './ReadonlyCommentBox.module.css'
import {clsx} from 'clsx'

type ReadonlyCommentBoxProps = {
  reason: string | JSX.Element
  ['data-testid']?: string
  icon?: Icon
}

export function ReadonlyCommentBox({reason, icon: Icon, ...props}: ReadonlyCommentBoxProps) {
  return (
    <div className={clsx('blankslate', readonlyCommentBox.ReadonlyCommentBoxContainer)} {...props}>
      <div className={readonlyCommentBox.centeredContent}>
        {Icon && <Icon size={24} />}
        <div className={styles.reason}>{reason}</div>
      </div>
    </div>
  )
}

try{ ReadonlyCommentBox.displayName ||= 'ReadonlyCommentBox' } catch {}